import React from "react";

const Landslide_Advisory = () => {
  return (
    <div className="cyclone-awareness">
      {/* <h6
        style={{
          textAlign: "left",
          fontSize: "1.5rem",
          backgroundColor: "rgb(202, 217, 239)",
          fontWeight: "bold",  
          padding: "0.5rem 1rem",
          borderRadius: "6px",
          marginBottom: "1rem"
        }}
      >
        General Advisory
      </h6> */}
      <table
        className="advisory-table"
        style={{ width: "100%", borderCollapse: "collapse" }}
      >
        <thead style={{ backgroundColor: "rgb(225, 232, 242)" }}>
          <tr>
            <th
              style={{
                border: "1px solid #ccc",
                padding: "10px",
                textAlign: "center",
              }}
            >
              Type
            </th>
            <th
              style={{
                border: "1px solid #ccc",
                padding: "10px",
                textAlign: "center",
              }}
            >
              Advisory in English
            </th>
            {/* <th
              style={{
                border: "1px solid #ccc",
                padding: "10px",
                textAlign: "center",
              }}
            >
              Avizu iha lian Tetum
            </th> */}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td
              style={{
                border: "1px solid #ccc",
                padding: "10px",
                verticalAlign: "top",
              }}
            >
              When a Landslide is Imminent
              <br />
              {/* <i>Bainhira Rai Halai Besik Ona</i> */}
            </td>
            <td style={{ border: "1px solid #ccc", padding: "10px" }}>
              <ul>
                <li>
                  Listen to local authorities or emergency services for
                  evacuation instructions.
                </li>
                <li>
                  Be prepared to leave your home immediately if there is a
                  landslide warning.
                </li>
                <li>Do not delay, evacuate early.</li>
                <li>
                  Avoid areas prone to landslides such as steep slopes, river
                  banks, and areas with loose soil.
                </li>
                <li>
                  Stay away from windows and doors as they can break during a
                  landslide.
                </li>
                <li>
                  Keep monitoring weather updates, as conditions can worsen
                  quickly.
                </li>
                <li>
                  If you’re driving, avoid roads that have a risk of landslides,
                  and take alternate routes.
                </li>
              </ul>
            </td>
            {/* <td style={{ border: "1px solid #ccc", padding: "10px" }}>
              <ul>
                <li>
                  Rona ba autoridade lokál ka serbisu emerjénsia nian ba
                  instrusaun evakuasaun nian.
                </li>
                <li>
                  Prepara an atu sai lalais husi uma bainhira iha avizu kona-ba
                  rai halai.
                </li>
                <li>Keta demora, evakua sedu.</li>
                <li>
                  Evita área sira ne’ebé risku ba rai halai hanesan foho lolon,
                  ninin mota, no área sira ne’ebé rai soluk.
                </li>
                <li>
                  Hadook an husi janela no odamatan tanba sira bele quebra
                  durante rai halai.
                </li>
                <li>
                  Kontinua akompaña informasaun kona-ba tempu, tanba kondisaun
                  bele agrava lalais.
                </li>
                <li>
                  Se ita kondús karreta, evita estrada sira ne’ebé iha risku ba
                  rai halai, no foti dalan seluk.
                </li>
              </ul>
            </td> */}
          </tr>
          <tr>
            <td
              style={{
                border: "1px solid #ccc",
                padding: "10px",
                verticalAlign: "top",
              }}
            >
              If You Are in an Area Affected by a Landslide
              <br />
              {/* <i>Se Ita iha Área ne’ebé Rai Halai Afeita</i> */}
            </td>
            <td style={{ border: "1px solid #ccc", padding: "10px" }}>
              <ul>
                <li>
                  If possible, seek shelter in a sturdy building away from
                  landslide-prone areas.
                </li>
                <li>
                  Do not attempt to cross landslide-affected areas, even if the
                  path looks clear.
                </li>
                <li>
                  If your house is in danger, move to higher ground or to a
                  nearby shelter.
                </li>
                <li>
                  Avoid using electrical appliances or open flames if you
                  suspect water or mud has entered the house.
                </li>
                <li>
                  Move to a safe location, keeping away from rivers or streams
                  that might flood due to the landslide.
                </li>
                <li>
                  Stay in communication with emergency services and follow their
                  instructions.
                </li>
              </ul>
            </td>
            {/* <td style={{ border: "1px solid #ccc", padding: "10px" }}>
              <ul>
                <li>
                  Se bele, buka abrigu iha edifísiu ida ne’ebé metin dook husi
                  área sira ne’ebé risku ba rai halai.
                </li>
                <li>
                  Keta koko atu travessa área sira ne’ebé rai halai afeita,
                  maski dalan parese livre.
                </li>
                <li>
                  Se ita-nia uma iha perigu, muda ba fatin aas liu ka ba abrigu
                  ida besik.
                </li>
                <li>
                  Evita uza aparellu elétriku ka ahi-lakan bainhira ita
                  deskonfia bee ka tahu tama ona uma laran.
                </li>
                <li>
                  Muda ba fatin seguru, hadook an husi mota ka bee-dalan sira
                  ne’ebé bele ইনুnda tanba rai halai.
                </li>
                <li>
                  Kontinua komunika ho serbisu emerjénsia no tuir sira-nia
                  instrusaun.
                </li>
              </ul>
            </td> */}
          </tr>
          <tr>
            <td
              style={{
                border: "1px solid #ccc",
                padding: "10px",
                verticalAlign: "top",
              }}
            >
              When Evacuation is Instructed
              <br />
              {/* <i>Bainhira Evakuasaun Hetan Instrusaun</i> */}
            </td>
            <td style={{ border: "1px solid #ccc", padding: "10px" }}>
              <ul>
                <li>
                  Pack essentials for yourself and your family, including
                  medications, water, and food that does not require cooking.
                </li>
                <li>
                  Follow evacuation routes and head for designated shelters.
                </li>
                <li>Do not worry about your property.</li>
                <li>
                  Once in the shelter, follow the instructions of emergency
                  personnel.
                </li>
                <li>
                  Stay in the shelter until you are told it is safe to return.
                </li>
              </ul>
            </td>
            {/* <td style={{ border: "1px solid #ccc", padding: "10px" }}>
              <ul>
                <li>
                  Empakota buat esensiál sira ba ita-nia an no ita-nia família,
                  inklui ai-moruk, bee, no ai-han ne’ebé la presiza te’in.
                </li>
                <li>
                  Tuir dalan evakuasaun nian no bá abrigu sira ne’ebé নির্ধারিত
                  ona.
                </li>
                <li>Keta preokupa kona-ba ita-nia propriedade.</li>
                <li>
                  Bainhira to’o iha abrigu, tuir instrusaun husi pesoál
                  emerjénsia nian.
                </li>
                <li>
                  hela iha abrigu to’o bainhira dehan katak seguru ona atu fila.
                </li>
              </ul>
            </td> */}
          </tr>
          <tr>
            <td
              style={{
                border: "1px solid #ccc",
                padding: "10px",
                verticalAlign: "top",
              }}
            >
              Post Landslide Measures
              <br />
              {/* <i>Medida Depois Rai Halai</i> */}
            </td>
            <td style={{ border: "1px solid #ccc", padding: "10px" }}>
              <ul>
                <li>
                  Remain in the shelter until authorities confirm it is safe to
                  return home.
                </li>
                <li>
                  If you are returning to your house, check for signs of
                  structural damage or new cracks.
                </li>
                <li>
                  Avoid entering areas with loose soil or debris, as further
                  landslides could occur.
                </li>
                <li>
                  Check for blocked roads and remain vigilant of additional
                  hazards in the area.
                </li>
                <li>
                  Report any damages or injuries to authorities immediately.
                </li>
                <li>
                  Ensure your home is properly cleared of debris and that
                  drainage systems are functioning to prevent future issues.
                </li>
              </ul>
            </td>
            {/* <td style={{ border: "1px solid #ccc", padding: "10px" }}>
              <ul>
                <li>
                  hela iha abrigu to’o autoridade sira konfirma katak seguru ona
                  atu fila ba uma.
                </li>
                <li>
                  Se ita fila ba ita-nia uma, verifika sinál sira kona-ba
                  estragu estruturál ka rahun foun.
                </li>
                <li>
                  Evita tama iha área sira ne’ebé rai soluk ka fo’er, tanba rai
                  halai seluk bele akontese.
                </li>
                <li>
                  Verifika estrada sira ne’ebé taka no kontinua vijilante ba
                  perigu adisionál sira iha área ne’e.
                </li>
                <li>
                  Relata kualkér estragu ka kanek ba autoridade sira
                  imediatamente.
                </li>
                <li>
                  Asegura katak ita-nia uma hamoos tiha ona fo’er ho didi’ak no
                  katak sistema drenajen funsiona hela atu prevene problema iha
                  futuru.
                </li>
              </ul>
            </td> */}
          </tr>
        </tbody>
      </table>
      Note: The report is valid until the specified [date and time]. Please monitor the website for additional information
      and alerts issued by the Department of Meteorology.

    </div>
  );
};

export default Landslide_Advisory;
